export const appRoutes = {
  HOME: "/",
  LORES: "lores",
  LORE: "lores/:gradisId",
  GIF: "gif",
  RARITY: "rarity",
  Discord: "https://discord.gg/tJV9NdVDfp",
  TWITTER: "https://twitter.com/_GRADIS_/",
  OPENSEA: "https://opensea.io/collection/gradis",
  CONVERTITO: "https://3d.gradis.art/",
};
